import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { httpIAPI_STA018 } from "./api/request";
import { funBodyList } from "./hooks/useHooks";
import { headList } from "../SCRW070011/parts";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
/**
 * SCRW070011 加入登録手続き
 * @returns JSX.Element
 */
const SCRW070011 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state: businessState } = useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const [bodyList, setBodyList] = useState<any>([]);
  const [facilityNameList, setFacilityNameList] = useState<any>([]);
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>("");

  // 初期表示
  const handleInit = async () => {
    // 加入登録手続き一覧参照API 呼び出し
    try {
      const res = await httpIAPI_STA018({
        applyId: location.state?.applyId,
      });

      if (res.resultCd === "I0000") {
        setCorpApplyKbn(res.corpApplyKbn);
        let names = res.facilityList?.map((item) => {
          return {
            name: item.facilityName,
            num: item.staffList?.length,
          };
        });

        setFacilityNameList(names);
        // レスポンスの値からコンポーネント形に変更
        let bodyList = funBodyList(res);

        setBodyList(bodyList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * @param data フォームのデータ
   */

  return (
    <>
      <Box className="SCRW070011" data-testid="SCRW070011PageForTest">
        <TkKikoStepper
          applicationFlowType="TYPE4"
          businessType="JOB-23"
          corporateApplicationClassification={corpApplyKbn}
          applicationStatus="13"
        ></TkKikoStepper>
        {/* TkInfoManualを表示 */}
        <TkInfoManual rule={"\\n"}>
          {labelids.labelid.LBLW070011_01}
        </TkInfoManual>
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState?.common?.contractorNo +
            ":" +
            businessState?.common?.contractorName
          }
        />
        <Box className="info">
          {facilityNameList.map((item: any, index: any) => {
            return (
              <Box key={index}>
                {item.name}登録人数:{item.num}人
              </Box>
            );
          })}

          <TkTable headList={headList} bodyList={bodyList}></TkTable>
        </Box>

        <Box className="buttonGroup">
          <TkBackButton mr />
          <TkViewButtonJudgement flowType={"TYPE4"} Status={"13"} />
        </Box>
      </Box>
    </>
  );
};

export default SCRW070011;
